import Button from '@rio-cloud/rio-uikit/Button';
import ButtonDropdown, { type ButtonDropdownProps } from '@rio-cloud/rio-uikit/ButtonDropdown';
import type { MenuItemProps } from '@rio-cloud/rio-uikit/MenuItem';
import { useIntl } from 'react-intl';

import type { OrderType } from '#domain/Order.ts';

type Props = {
    title: string;
    onSelect: (type: OrderType) => void;
    bsStyle?: ButtonDropdownProps['bsStyle'];
    id?: string;
};

export const CreateOrderButton = ({ title, onSelect, bsStyle = Button.PRIMARY, id }: Props) => {
    const intl = useIntl();

    const items: MenuItemProps[] = [
        {
            value: (
                <span className='display-flex align-items-center gap-5'>
                    <span className='uikit-icon icon-truck' />
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.order.type.transport',
                    })}
                </span>
            ),
            onSelect: () => onSelect('transport'),
        },
        {
            value: (
                <span className='display-flex align-items-center gap-5'>
                    <span className='uikit-icon icon-wrench' />
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.order.type.service',
                    })}
                </span>
            ),
            onSelect: () => onSelect('service'),
        },
    ];

    return (
        <ButtonDropdown
            id={id}
            title={<span>{title}</span>}
            bsStyle={bsStyle}
            dropdownClassName='white-space-nowrap'
            items={items}
        />
    );
};
